import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkDelete: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookmarkDelete"><Path d="M19.5 21V2.5H4.5V21L12 17L19.5 21Z" stroke="currentColor" strokeLinecap="square"/><Path d="M14.4749 7.52539L9.52515 12.4751" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M14.4749 12.4751L9.52515 7.52539" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBookmarkDelete;
